/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/button-has-type */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-this-in-sfc */
import {
  Button,
  Paper,
  Grid,
  Stack,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Divider,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  OutlinedInput,
  InputAdornment,
  Autocomplete,
  IconButton,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import countries from 'i18n-iso-countries';
import { getCountryCallingCode } from 'libphonenumber-js';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTheme } from '@emotion/react';
import { Form, Formik, useFormikContext } from 'formik';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import * as Yup from 'yup';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import logoImage from '../../media/login/logo.png';
import bg4 from '../../media/login/bg.jpeg';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import successIcon from '../../media/success_icon.png';
import '../stylemod.css';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundImage: `url("${bg4}")`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  mixBlendMode: 'multiply',
  marging: 'auto',
}));

const initalStates = {
  // tab 1
  existingUser: '',
  // tab 2
  firstName: '',
  lastName: '',
  dob: '',
  addr1: '',
  addr2: '',
  addr3: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  tel: '',
  mailid: '',
  coo: '',
  branch: '',
  // tab 3
  otp: '',
  otpSent: false,
  otpVerified: '',
  // tab 4
  password: '',
  confirmPassword: '',
  acceptTerms: false,
  captchaToken: '',
};

console.log(initalStates, 'initalStates')

const Countrys = {
  INDIA: 'IN',
  'UNITED KINGDOM': 'UK',
};











const FormikState = () => {
  const { values } = useFormikContext();
  const navigate = useNavigate();


  const handleBeforeUnload = (event) => {
    if (values.tel !== "" || values.mailid !== "") {
      SaveCRMdata(values);
    }

    if (performance.navigation.type === 1) {
      console.log("Page reload detected");
    } else {
      console.log("Page close or navigation detected");
      event.returnValue = "You have unsaved changes. Do you really want to leave?";
    }
  };

  const handlePopState = (event) => {
    // Show a confirmation dialog when back navigation is detected
    const message = "You have unsaved changes. Do you really want to leave?";
    const userConfirmed = window.confirm(message);

    if (userConfirmed) {
      console.log("User confirmed back navigation.");
      if (values.tel !== "" || values.mailid !== "") {
        SaveCRMdata(values)
          .then(() => {
            // console.log("Data saved successfully.");
            // Allow navigation after saving
            navigate('/login')
          })
      }

      // .catch((error) => {
      //   console.error("Error saving data:", error);
      // });
    } else {
      console.log("User canceled back navigation.");
      // Push the current state back to prevent navigation
      window.history.pushState(null, "", window.location.href);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Push an initial state to allow canceling back navigation
    window.history.pushState(null, "", window.location.href);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [values]);

  return null;
};


const SaveCRMdata = async (values) => {
  console.log(values, 'SaveCRMdata');

  try {
    // showLoading();             

    // Mapping values from the form into newData
    const newData = {
      firstName: values.firstName !== '' ? values.firstName : '',
      lastName: values.lastName !== '' ? values.lastName : '',
      dateOfBirth: values.dob !== '' ? moment(values.dob).format('YYYY-MM-DD') : '',
      address1: values.addr1 !== '' ? values.addr1 : '',
      address2: values.addr2 || '',
      address3: values.addr3 || '',
      origin: values.coo || '',
      // country:  values.country?.CountryName || '',   
      country: '',
      state: values.state || '',
      city: values.city || '',
      postalCode: values.pincode || '',
      contactNo: values.tel || '',
      alternativeNo: values.altTel || values.tel || '',
      email: values.mailid || '',
      branchId: values.branch || '',
    };

    // Make the API call (replace 'SignUp/GetCRMdata' with your actual endpoint)
    const response = await axios.post('SignUp/SaveCRMdata', newData);

    console.log(response.data, 'API response');
  } catch (e) {
    // openSnackBar(e.response?.data?.message || 'Something went wrong! Try again.', 'error');
  } finally {
    // hideLoading();
  }
};




const SignUpForm = () => {
  const [otpSent, setOtpSent] = useState(false);
  const [invalidOtp, setInvalidOtp] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [initialValue, setInitialValue] = useState(initalStates);
  const [existingUserFound, setExistingUserFound] = useState(false);
  const [approvalPending, setApprovalPending] = useState(false);
  const [alreadyRegistered, setAlreadyRegistered] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [existingUserData, setExistingUserData] = useState([]);
  const [noUserFound, setNoUserFound] = useState(false);
  const [existingMessageOpen, setExistingMessageOpen] = useState(false);
  const [nextClicked, setNextClicked] = React.useState(false);
  const [termsConditions, setTermsConditions] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);
  const [telCode, setTelCode] = useState('  ');
  const [showPassword, setShowPassword] = useState(false);
  const otpSendedEmail = useRef({});
  const theme = useTheme();
  const navigate = useNavigate();
  const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false);
  const togglePasswordVisibility = () => setPasswordVisibility((prev) => !prev);
  const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisibility((prev) => !prev);

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          existingUser: Yup.string().required('Choose any option'),
          acceptTerms: Yup.boolean()
            .oneOf([true], 'You must agree to the terms and conditions')
            .required('You must agree to the terms'),
          otpSent: Yup.boolean(),
          otp: Yup.string().length(4, 'OTP is required and must be 4 digits'),
          otpVerified: Yup.boolean().required(),
          captchaToken: Yup.string().required('Please complete the reCAPTCHA'),
          password: Yup.string()
            .min(6, 'Password must be at least 6 characters long')
            .max(15, 'Password cannot exceed 15 characters')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
            .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
            .required('Password is required'),
          confirmPassword: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords must match')
            .required('Please confirm your password'),
          coo: Yup.string().required('Country of origin is required'),
          tel: Yup.string().required('Contact number is required')
            .matches(/^\d+$/, 'Contact number must contain only digits')
            .min(9, 'Contact number must be at least 9 digits')
            .max(15, 'Contact number must not exceed 15 digits'),
          // tel: Yup.string().required('Phone number is required').min(9, 'Invalid phone number length'),
          ...(values.existingUser !== 'Y'
            ? {
              firstName: Yup.string().required('Enter First name').min(3, 'First name is too short'),
              lastName: Yup.string().min(2, 'Last name is too short'),
              dob: Yup.date()
                .nullable()
                .required('Date of birth is required')
                .test('valid-year', 'Year must be realistic (between 1900 and current year)', function (value) {
                  if (!value) return false;
                  const year = new Date(value).getFullYear();
                  const currentYear = new Date().getFullYear();
                  return year >= 1900 && year <= currentYear;
                }),
              // dob: Yup.date().nullable().required('Date of birth is required'),
              addr1: Yup.string().required('Address 1 is required'),
              addr2: Yup.string(),
              addr3: Yup.string(),
              city: Yup.string().required('Enter your city'),
              alterTel: Yup.string().matches(/^\d+$/, 'Alternative Contact number must contain only digits')
                .min(9, 'Alternative Contact number must be at least 9 digits')
                .max(15, 'Alternative Contact number must not exceed 15 digits'),
              // state: values.coo==='IN'?Yup.object().required('Select state'):Yup.object(),
              country: Yup.object().required('Select country'),
              pincode: Yup.string()
                .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
                .max(15, 'Pincode cannot exceed 15 characters')
                .required('Pincode is required'),
              branch: Yup.string().required('Branch is required'),
              mailid: Yup.string()
                .email('Invalid email format')
                .max(50, 'Mail ID cannot exceed 50 characters')
                .required('Mail ID is required')
                .test(
                  'email-exists',
                  'This email is already registered. Please use another email or log in with existing credentials.',
                  async (value) => {
                    if (!value) return false;
                    try {
                      const response = await axios.post('login/verifyEmailId', { EmailId: value });
                      const data = response.data;
                      return data.length === 0;
                    } catch (err) {
                      console.error(err);
                      return false;
                    }
                  }
                ),
            }
            : {
              mailid: Yup.string()
                .email('Invalid email format')
                .max(50, 'Mail ID cannot exceed 50 characters')
                .required('Mail ID is required')
                .test(
                  'email-exists',
                  'This email is already registered. Please use another email or log in with existing credentials.',
                  async (value) => {
                    if (!value) return false;
                    try {
                      const response = await axios.post('login/verifyEmailIdWithApproved', { EmailId: value });
                      const data = response.data;
                      return data.length === 0;
                    } catch (err) {
                      console.error(err);
                      return false;
                    }
                  }
                ),
            }),
        })
      ),
    []
  );

  useEffect(() => {
    sessionStorage.setItem('country', 'IN');
  }, []);



  // tabing
  const [tabValue, setTabValue] = useState(0);

  const tabFeilds = [
    ['existingUser'],
    [
      'firstName',
      'lastName',
      'dob',
      'addr1',
      'addr2',
      'addr3',
      'city',
      'state',
      'country',
      'pincode',
      'tel',
      'alterTel',
      'mailid',
      'Country',
      'coo',
      'branch',
    ],
    ['otp', 'otpVerified'],
    ['password', 'confirmPassword', 'acceptTerms', 'captchaToken'],
  ];

  const handleTabChange = (event, newValue, setFieldTouched, validateForm) => {
    if (tabValue >= newValue) {
      setTabValue(newValue);
    } else {
      const validationFields = tabFeilds.slice(0, newValue).flat();
      validationFields.forEach((field) => {
        setFieldTouched(field, true);
      });
      validateForm().then((updatederr) => {
        const ErrorFields = validationFields.filter((field) => updatederr[field]);
        setTabValue(ErrorFields.length === 0 ? newValue : tabValue);
      });
    }
  };

  async function InsertCustomerTimeLine(customerid, FollowUpUser, BranchId) {
    const newData = {
      Optype: 'New',
      customerId: customerid,
      companyId: 4,
      branchId: BranchId,
      Order_ID: 0,
      Order_Type: '',
      remarks: '',
      followup: FollowUpUser === 'Y' ? 'Existing User' : 'New User',
      followupDate: new Date(),
      createdBy: '',
      createdOn: new Date(),
    };

    try {
      showLoading();
      const response = await axios.post('signup/InsertCustomerTimeline', newData);
      // if (response.status === 200) {
      //   openSnackBar('Customer Timeline Created Successfully!', 'success');
      // }
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertCompany(values) {
    const newData = {
      CustomerName: `${values.firstName} ${values.lastName}`,
      CustomerCode: '',
      Password: values.password,
      Address1: values.addr1,
      Address2: values.addr2,
      Address3: values.addr3,
      DOB: moment(values.dob).format('YYYY-MM-DD'),
      City: values.city,
      ZipCode: values.pincode,
      Phone: values.tel,
      AlternativePhone: values.alterTel || '',
      EmailId: values.mailid,
      WebAccess: 'P',
      Origin: values.coo,
      BrnachID: values.branch,
      CreatedBy: 0,
      CompanyId: 4,
      ...values.country,
      ...values.state,
      UserType: 'New User',
    };
    const config = {
      headers: {
        Country: values.coo,
      },
    };
    try {
      showLoading();
      console.log(values, 'values');
      const response = await axios.post('signup/SaveCustomerSignUp', newData, config);
      await sendsingupMail(response.data.CustomerId, '', false);
      await InsertCustomerTimeLine(response.data.CustomerId, values.existingUser, values.branch);
      setExistingUserFound(false);
      setIsSubmitted(true);
      setExistingMessageOpen(true);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function LoginApprovalExistingUser(values) {
    const newData = {
      CustomerId: existingUserData.CustomerId,
      Password: values.password,
      Origin: values.coo,
      UserType: 'Exisiting User',
      CreatedBy: 0,
      EmailId: otpSendedEmail.current
    };
    try {
      showLoading();
      // console.log(values, 'LoginApprovalExistingUser',otpSendedEmail);
      const response = await axios.post('signup/LoginApprovalExistingUser', newData);
      await sendsingupMail(existingUserData.CustomerId, otpSendedEmail.current, true);
      await InsertCustomerTimeLine(existingUserData.CustomerId, values.existingUser, values.branch);
      setExistingUserFound(false);
      setIsSubmitted(true);
      setExistingMessageOpen(true);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendsingupMail(customerid, existingUserEmailid, isExistingUser) {
    try {
      showLoading();
      const response = await axios.post('signup/sendSignUpMail', {
        CustomerId: customerid,
        ExistingUserEmailid: existingUserEmailid,
        IsExistingUser: isExistingUser
      });
      if (response.status === 200) {
        // openSnackBar('Mail Has Been Sent Successfully!, Please check Your Email', 'success');
        LedgerApprovalReq(customerid);
      }
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function LedgerApprovalReq(customerid) {
    try {
      showLoading();
      const response = await axios.post('signup/LedgerApprovalRequest', {
        customerid,
      });
      if (response.status === 200) {
        openSnackBar('Mail Has Been Sent Successfully!, Please check Your Email', 'success');
      }
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendOtp(email) {
    try {
      showLoading();
      const response = await axios.post('signup/sendOtp', {
        Email: email,
        isForgotPassword: 'N',
      });
      // console.log(response.status === 200, 'response.status === 200');
      // console.log(response, 'response.status === 200');
      if (response.status === 200) {
        openSnackBar('Otp Has Been Sent Successfully!, Please check Your Email', 'success');
        setOtpSent(true);
      }
    } catch (e) {
      openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function verifyOtp(email, otp) {
    try {
      showLoading();
      const response = await axios.post('signup/verifyOtp', {
        Email: email,
        Otp: otp,
      });
      if (response.status === 200) {
        setOtpVerified(true);
        setInvalidOtp(false);
      } else {
        setInvalidOtp(true);
        setTimeout(() => {
          setInvalidOtp(false);
        }, 3000);
      }
    } catch (e) {
      setInvalidOtp(true);
      setTimeout(() => {
        setInvalidOtp(false);
      }, 3000);
    }
    hideLoading();
  }

  async function VerifyExistingUser(tel, country) {
    try {
      showLoading();
      const requestData = {
        Phone: tel,
      };

      const response = await axios.post('signup/VerifyExistingUser', requestData);
      if (response.status === 200) {
        setExistingUserData(response.data[0]);
        if (response.data[0].WebAccess === 'P') {
          setApprovalPending(true);
          setExistingMessageOpen(true);
        } else if (response.data[0].WebAccess === 'Y') {
          setAlreadyRegistered(true);
          setExistingMessageOpen(true);
        } else {
          setExistingUserFound(true);
          setExistingMessageOpen(true);
        }
      }
    } catch (e) {
      setNoUserFound(true);
      setTimeout(() => {
        setNoUserFound(false);
      }, 3000);
    }
    hideLoading();
  }

  async function GetTermsAndCondition(cntry) {
    try {
      showLoading();
      const response = await axios.get('signup/GetTermsAndCondition/11');
      setTermsConditions(response.data);
    } catch (e) {
      // openSnackBar(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: 4,
      };
      const response = await axios.post('signup/GetBranchList', requestData);
      const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
  }

  const getCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };
  const getStateList = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setStateList(res.data);
    } catch (err) {
      setStateList([]);
      console.log(err.message);
    }
  };
  const findTelCode = (countryName) => {
    try {
      const countryCode = countries.getAlpha2Code(countryName, 'en');
      setTelCode(`+${getCountryCallingCode(countryCode)}`);
    } catch {
      setTelCode('  ');
    }
  };
  const handleCountryChange = (value) => {
    if (!value) return;
    getStateList(value.CountryId);
    findTelCode(value.CountryName);
  };

  const handleOriginHeader = (e, handleChange) => {
    axios.defaults.headers.country = e.target.value;
    sessionStorage.setItem('country', e.target.value);
    handleChange(e);
  };

  const handleNext = async (
    e,
    coo,
    email,
    existingUser,
    setFieldTouched,
    setFieldValue,
    validateForm,
    setFieldError
  ) => {
    // if (tabValue === 0 && existingUser === 'N') {
    //   getCountryList();
    //   GetBranchList(coo);
    // }
    if (tabValue === 1 && email !== otpSendedEmail.current) {
      setOtpSent(false);
      setOtpVerified(false);
      otpSendedEmail.current = email;
      setFieldValue('otp', '');
    }
    if (tabValue === 2) GetTermsAndCondition(coo);
    handleTabChange(e, tabValue + 1, setFieldTouched, validateForm);
  };

  return (
    <>
      <StyledRoot>
        <StyledSection>
          <Paper sx={{ pt: 2, backgroundColor: 'white', mx: smallScreen ? 0 : 25, minHeight: '70vh' }}>
            {/* table header */}
            <Stack direction="column" justifyContent="center" alignItems={'center'} gap={1} py={2}>
              <button
                onClick={() => navigate('/login')}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                }}
              >
                <img
                  src={logoImage}
                  style={{
                    objectFit: 'contain',
                    maxWidth: '150px',
                  }}
                  alt="techveel logo"
                />
              </button>
              <Typography
                variant="h5"
                borderColor="#11235A"
                textAlign={'center'}
                sx={{
                  color: 'black',
                }}
              >
                <Typography variant="h2" color="black" className="font_style1" textAlign={'center'}>
                  Sign Up for Smarter Shipping with <span style={{ color: '#347928' }}> Inspection On Go </span>
                </Typography>
              </Typography>
            </Stack>

            <Divider />

            <Stack sx={{ p: 4 }}>
              <Formik
                validationSchema={ValidationSchema}
                initialValues={initialValue}
                onSubmit={async (values, { resetForm }) => {
                  if (values.existingUser === 'N') {
                    await InsertCompany({ ...initalStates, ...values });
                  } else {
                    await LoginApprovalExistingUser({ ...initalStates, ...values });
                  }
                  resetForm();
                  setTelCode('  ');
                }}
              >
                {({
                  submitForm,
                  touched,
                  values,
                  errors,
                  handleChange,
                  handleBlur,
                  isSubmitting,
                  resetForm,
                  setFieldTouched,
                  setFieldError,
                  validateForm,
                  setFieldValue,
                }) => (
                  <Form>
                    <FormikState />
                    <Tabs
                      sx={{
                        mb: 3,
                      }}
                      value={tabValue}
                      onChange={(e, values) => {
                        if (values === 2) {
                          return; // Prevent the tab change
                        }
                        handleTabChange(e, values, setFieldTouched, validateForm);
                      }}
                      scrollButtons
                      allowScrollButtonsMobile
                      aria-label="scrollable force tabs example"
                      centered
                    >
                      <Tab label="Lets Begin" value={0} />
                      <Tab
                        label="Basic Info"
                        value={1}
                        onClick={() => {
                          if (values.existingUser === 'N' && tabValue === 0 && !errors.existingUser) {
                            getCountryList();
                            GetBranchList();
                          }
                        }}
                      />
                      <Tab label="OTP Verification" value={2} />
                      <Tab label="Complete Registration" value={3} />
                    </Tabs>
                    {/* User Type */}
                    {tabValue === 0 && (
                      <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                        <Grid item xs={12}>
                          <Stack justifyContent={'center'} alignItems={'center'} direction={'column'} spacing={2}>
                            <Typography variant="h3" color="#347928" className="font_style1" textAlign={'center'}>
                              Do you have a Inspection On Go Account ?
                            </Typography>

                            <ToggleButtonGroup
                              color="success"
                              value={values.existingUser} // Bind to Formik's values
                              exclusive
                              onChange={async (event, newValue) => {
                                resetForm();
                                setTelCode('  ');
                                await setFieldValue('existingUser', newValue);
                                setExistingUserFound(false);
                                handleNext(
                                  event,
                                  '',
                                  '',
                                  newValue,
                                  setFieldTouched,
                                  setFieldValue,
                                  validateForm,
                                  setFieldError
                                );
                              }}
                              aria-label="Platform"
                              size="large"
                            >
                              <ToggleButton value="Y">Yes</ToggleButton>
                              <ToggleButton value="N" color="warning">
                                No
                              </ToggleButton>
                            </ToggleButtonGroup>

                            {errors.existingUser && touched.existingUser && (
                              <Typography
                                variant="caption"
                                color="error"
                                className="shake-helper-text"
                                margin="4px 0 0 14px"
                              >
                                {errors.existingUser}
                              </Typography>
                            )}
                          </Stack>
                        </Grid>
                      </Grid>
                    )}
                    {/* Basic Info */}
                    {tabValue === 1 && (
                      <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                        {values.existingUser === 'N' && (
                          <>
                            <Grid item md={4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="First Name"
                                type="text"
                                name="firstName"
                                onBlur={handleBlur}
                                error={touched.firstName && !!errors.firstName}
                                helperText={touched.firstName && errors.firstName ? errors.firstName : ''}
                                value={values.firstName}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Last Name"
                                type="text"
                                name="lastName"
                                onBlur={handleBlur}
                                error={touched.lastName && !!errors.lastName}
                                helperText={touched.lastName && errors.lastName ? errors.lastName : ''}
                                value={values.lastName}
                                onChange={handleChange}
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Date Of Birth"
                                type="date"
                                inputProps={{ max: '9999-12-31' }}
                                name="dob"
                                InputLabelProps={{ shrink: true }}
                                onBlur={handleBlur}
                                error={touched.dob && !!errors.dob}
                                helperText={touched.dob && errors.dob ? errors.dob : ''}
                                value={values.dob}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={4} xs={12}>
                              <TextField
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                label="Address 1"
                                name="addr1"
                                onBlur={handleBlur}
                                error={touched.addr1 && !!errors.addr1}
                                helperText={touched.addr1 && errors.addr1 ? errors.addr1 : ''}
                                value={values.addr1}
                                onChange={handleChange}
                                required
                              />
                            </Grid>

                            <Grid item md={4} xs={12}>
                              <TextField
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                label="Address 2"
                                name="addr2"
                                onBlur={handleBlur}
                                error={touched.addr2 && !!errors.addr2}
                                helperText={touched.addr2 && errors.addr2 ? errors.addr2 : ''}
                                value={values.addr2}
                                onChange={handleChange}
                              />
                            </Grid>

                            <Grid item md={4} xs={12}>
                              <TextField
                                multiline
                                rows={3}
                                fullWidth
                                size="small"
                                label="Address 3"
                                name="addr3"
                                onBlur={handleBlur}
                                error={touched.addr3 && !!errors.addr3}
                                helperText={touched.addr3 && errors.addr3 ? errors.addr3 : ''}
                                value={values.addr3}
                                onChange={handleChange}
                              />
                            </Grid>
                          </>
                        )}
                        {!existingUserFound && (
                          <Grid item md={values.existingUser === 'N' ? 2 : 4} xs={12}>
                            <FormControl fullWidth size="small" fullwidth required>
                              <InputLabel id="Country-select-label">Origin</InputLabel>
                              <Select
                                fullWidth
                                labelId="Country-select-label"
                                value={values.coo}
                                size="small"
                                name="coo"
                                label="Origin"
                                onChange={(e) => {
                                  handleOriginHeader(e, handleChange);
                                  getCountryList();
                                  setFieldValue('country', '');
                                  setFieldValue('state', '');
                                  setStateList([])
                                  GetBranchList();
                                }}
                                error={touched.coo && !!errors.coo}
                                required
                              >
                                {Object.entries(Countrys).map(([fullName, code]) => (
                                  <MenuItem key={code} value={code}>
                                    {fullName}
                                  </MenuItem>
                                ))}
                              </Select>
                              {touched.coo && errors.coo && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    className="shake-helper-text"
                                    margin="0 0 0 14px"
                                  >
                                    {errors.coo}
                                  </Typography>
                                </Grid>
                              )}
                            </FormControl>
                          </Grid>
                        )}
                        {values.existingUser === 'N' && (
                          <>
                            <Grid item md={3} xs={12}>
                              <Autocomplete
                                options={countryList}
                                getOptionLabel={(country) => country.CountryName}
                                renderOption={(props, country) => (
                                  <li {...props} key={country.Countryid}>
                                    {country.CountryName}
                                  </li>
                                )}
                                isOptionEqualToValue={(country) => country.CountryId === values.country.CountryId}
                                value={values.country || null}
                                name="country"
                                onChange={(event, value) => {
                                  handleCountryChange(value);
                                  setFieldValue('country', value);
                                  setFieldValue('state', null);
                                }}
                                size="small"
                                onBlur={() => {
                                  setFieldTouched('country', true);
                                }}
                                required
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Residing Country"
                                    error={touched.country && !!errors.country}
                                    helperText={touched.country && errors.country}
                                    required
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <Autocomplete
                                options={stateList}
                                getOptionLabel={(state) => state.StateName}
                                renderOption={(props, state) => (
                                  <li {...props} key={state.Stateid}>
                                    {state.StateName}
                                  </li>
                                )}
                                isOptionEqualToValue={(state) => state.StateId === values.state.StateId}
                                value={values.state || null}
                                name="state"
                                onChange={(event, value) => {
                                  setFieldValue('state', value);
                                }}
                                size="small"
                                onBlur={() => {
                                  setFieldTouched('state', true);
                                }}
                                renderInput={(params) => <TextField {...params} label="State" />}
                              />
                              {/* error={touched.state && !!errors.state}
                                helperText={touched.state && errors.state} */}
                            </Grid>
                            <Grid item md={2} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="City"
                                type="text"
                                name="city"
                                onBlur={handleBlur}
                                error={touched.city && !!errors.city}
                                helperText={touched.city && errors.city ? errors.city : ''}
                                value={values.city}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                            <Grid item md={2} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Postal Code"
                                type="text"
                                name="pincode"
                                onBlur={handleBlur}
                                error={touched.pincode && !!errors.pincode}
                                helperText={touched.pincode && errors.pincode ? errors.pincode : ''}
                                value={values.pincode}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                          </>
                        )}
                        {!existingUserFound && (
                          <>
                            <Grid item md={values.existingUser === 'N' ? 3 : 8} xs={12}>
                              <FormControl fullWidth size="small" required>
                                <InputLabel htmlFor="outlined-adornment-tel">Contact No</InputLabel>
                                <OutlinedInput
                                  id="outlined-adornment-tel"
                                  type="text"
                                  name="tel"
                                  value={values.tel}
                                  onChange={(e) => {
                                    const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                    handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                                  }}
                                  // onChange={handleChange}
                                  onBlur={handleBlur}
                                  label="Contact No"
                                  error={touched.tel && !!errors.tel}
                                  required
                                  startAdornment={
                                    <InputAdornment position="start">
                                      {values.existingUser === 'Y' ? '' : telCode}
                                    </InputAdornment>
                                  } // Optional prefix
                                />
                                {touched.tel && errors.tel && (
                                  <Typography variant="caption" color="error">
                                    {errors.tel}
                                  </Typography>
                                )}
                              </FormControl>
                            </Grid>
                            {values.existingUser === 'N' && (
                              <Grid item md={3} xs={12}>
                                <FormControl fullWidth size="small">
                                  <InputLabel htmlFor="outlined-adornment-tel">Alternative No</InputLabel>
                                  <OutlinedInput
                                    id="outlined-adornment-tel"
                                    type="number"
                                    name="alterTel"
                                    value={values.alterTel}
                                    // onChange={handleChange}
                                    onChange={(e) => {
                                      const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                      handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                                    }}
                                    onBlur={handleBlur}
                                    label="Alternative No"
                                    error={touched.alterTel && !!errors.alterTel}
                                    startAdornment={
                                      <InputAdornment position="start">
                                        {values.existingUser === 'Y' ? '' : telCode}
                                      </InputAdornment>
                                    } // Optional prefix
                                  />
                                  {touched.alterTel && errors.alterTel && (
                                    <Typography variant="caption" color="error">
                                      {errors.alterTel}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Grid>
                            )}
                          </>
                        )}
                        {values.existingUser === 'Y'
                          ? existingUserFound && (
                            <Grid item md={existingUserFound ? 12 : 4} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Email"
                                type="email"
                                name="mailid"
                                onBlur={handleBlur}
                                error={touched.mailid && !!errors.mailid}
                                helperText={touched.mailid && errors.mailid ? errors.mailid : ''}
                                value={values.mailid}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                          )
                          : values.existingUser === 'N' && (
                            <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Email"
                                type="email"
                                name="mailid"
                                onBlur={handleBlur}
                                error={touched.mailid && !!errors.mailid}
                                helperText={touched.mailid && errors.mailid ? errors.mailid : ''}
                                value={values.mailid}
                                onChange={handleChange}
                                required
                              />
                            </Grid>
                          )}
                        {values.existingUser === 'N' && (
                          <Grid item md={3} xs={12}>
                            <FormControl fullWidth size="small" required>
                              <InputLabel>Branch</InputLabel>
                              <Select
                                value={values.branch || ''}
                                name="branch"
                                size="small"
                                label="Branch"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.branch && !!errors.branch}
                                required
                              >
                                {branchList.length > 0 ? (
                                  branchList.map((branch) => (
                                    <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                      {branch.BranchName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No branches available</MenuItem>
                                )}
                              </Select>
                              {touched.branch && errors.branch && (
                                <Typography
                                  variant="caption"
                                  color="error"
                                  className="shake-helper-text"
                                  margin="4px 0 0 14px"
                                >
                                  {errors.branch}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                        )}
                        {noUserFound && (
                          <Grid item xs={12}>
                            <Stack justifyContent={'center'} alignItems={'center'} direction={'column'} spacing={2}>
                              <Typography variant="caption" color="error">
                                Record not Found, Please enter correct contact number.
                              </Typography>
                            </Stack>
                          </Grid>
                        )}
                        {(values.existingUser === 'N' || (values.existingUser === 'Y' && !existingUserFound)) &&
                          <Grid xs={12} pl='32px' sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} mt='20px'>
                            <InfoIcon sx={{ color: 'red' }} />
                            <Typography variant='caption' sx={{ color: '#0b4ca2' }}>
                              For <span style={{ color: '#06a352' }}>UK - Overall</span> select origin as <u>UK</u>. For <span style={{ color: '#06a352' }}>India - Overall</span> select origin as <u>INDIA</u>.
                            </Typography>
                          </Grid>
                        }
                      </Grid>
                    )}

                    {/* OTP Verification */}
                    {tabValue === 2 && (
                      <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                        <Grid item xs={12}>
                          <Stack justifyContent={'center'} alignItems={'center'} direction={'column'} spacing={2}>
                            {otpVerified ? (
                              <Typography variant="body1" color="success.main">
                                OTP verified! You can proceed to the next step.
                              </Typography>
                            ) : otpSent ? (
                              <Typography
                                variant="body1"
                                color="text.secondary"
                                gutterBottom
                                textAlign="center"
                                sx={{ px: 10 }}
                              >
                                We've sent an OTP to{' '}
                                <strong style={{ color: 'green', marginLeft: 3 }}>{otpSendedEmail.current}</strong>.
                                Please enter the OTP below to verify your email and continue.
                              </Typography>
                            ) : (
                              <Typography
                                variant="body1"
                                color="text.secondary"
                                gutterBottom
                                textAlign="center"
                                sx={{ px: 10 }}
                              >
                                For security purposes, an OTP will be sent to
                                <strong style={{ color: 'green', marginLeft: 3 }}>{otpSendedEmail.current}</strong>,
                                click the 'Send OTP' button below to initiate the verification process.
                              </Typography>
                            )}

                            {!otpSent && (
                              <Button
                                variant="outlined"
                                color="success"
                                onClick={() => {
                                  if (otpSendedEmail.current) {
                                    sendOtp(otpSendedEmail.current);
                                  } else {
                                    // console.log('Mail ID is required');
                                  }
                                }}
                              >
                                Send OTP
                              </Button>
                            )}

                            {otpSent && !otpVerified && (
                              <>
                                {/* OTP Input Field */}
                                <TextField
                                  size="small"
                                  label="Enter OTP"
                                  type="text"
                                  name="otp"
                                  value={values.otp}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  error={touched.otp && !!errors.otp}
                                  helperText={touched.otp && errors.otp ? errors.otp : ''}
                                />
                                <Typography
                                  align="right"
                                  variant="body2"
                                  color="primary"
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setFieldValue('otp', '');
                                    sendOtp(otpSendedEmail.current);
                                  }}
                                >
                                  Re-send OTP
                                </Typography>

                                {/* Verify OTP Button */}
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    verifyOtp(values.mailid, values.otp);
                                    setFieldValue('otpVerified', 'true');
                                  }}
                                >
                                  Verify OTP
                                </Button>
                              </>
                            )}
                            {invalidOtp && (
                              <Typography variant="caption" color="error">
                                Invalid OTP, please try again.
                              </Typography>
                            )}

                            {nextClicked && !otpVerified && (
                              <Typography variant="caption" color="error">
                                Please complete the verification process.
                              </Typography>
                            )}
                          </Stack>
                        </Grid>
                      </Grid>
                    )}

                    {/* Complte Registration */}
                    {tabValue === 3 && (
                      <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                        <Grid item xs={12}>
                          <Stack justifyContent="center" alignItems="center" spacing={3}>
                            {/* Thank You and Username Display */}
                            <Typography variant="h6" color="primary">
                              Thank you for completing the email verification process!
                            </Typography>
                            <Typography variant="body1" color="textSecondary" textAlign="center">
                              Your username will be your registered email:
                              <strong style={{ color: 'green', marginLeft: '5px' }}>{values.mailid}</strong>
                            </Typography>
                          </Stack>
                        </Grid>

                        <Grid item xs={12}>
                          <Stack direction="column" justifyContent="center" alignItems="center" gap={2} width={'100%'}>
                            <TextField
                              size="small"
                              name="password"
                              label="Password"
                              type={passwordVisibility ? 'text' : 'password'}
                              autoComplete="off"
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={!!errors.password && touched.password}
                              helperText={touched.password && errors.password ? errors.password : ''}
                              required
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={togglePasswordVisibility} edge="end">
                                      {passwordVisibility ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <TextField
                              size="small"
                              name="confirmPassword"
                              label="Confirm Password"
                              type={confirmPasswordVisibility ? 'text' : 'password'}
                              autoComplete="off"
                              value={values.confirmPassword}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={!!errors.confirmPassword && touched.confirmPassword}
                              helperText={
                                touched.confirmPassword && errors.confirmPassword ? errors.confirmPassword : ''
                              }
                              required
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={toggleConfirmPasswordVisibility} edge="end">
                                      {confirmPasswordVisibility ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                            />

                            <Typography
                              variant="body2"
                              color="textSecondary"
                              textAlign="center"
                              sx={{ maxWidth: '80%' }}
                            >
                              <span style={{ color: 'red', fontWeight: 'bold' }}>Note:</span> please create a secure
                              password to complete your registration. Your password must be at least 6 characters long
                              and include one uppercase letter, one lowercase letter and one special
                              character.
                            </Typography>
                          </Stack>
                        </Grid>
                        {/* Terms and Conditions Checkbox */}
                        <Grid item xs={12}>
                          <Stack direction="column" alignItems="center" gap={2}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.acceptTerms}
                                  onChange={handleChange}
                                  name="acceptTerms"
                                  color="primary"
                                />
                              }
                              label={
                                <span>
                                  I agree to the{' '}
                                  <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => setTermsDialogOpen(true)}
                                    sx={{ textTransform: 'none', padding: 0, color: 'primary.main' }}
                                  >
                                    terms and conditions
                                  </Button>
                                </span>
                              }
                            />
                            {touched.acceptTerms && errors.acceptTerms && (
                              <Typography variant="caption" color="error">
                                {errors.acceptTerms}
                              </Typography>
                            )}
                          </Stack>
                        </Grid>

                        {/* Google reCAPTCHA */}
                        <Grid item xs={12} textAlign="center">
                          <Stack direction="column" justifyContent="center" alignItems="center" gap={2} width={'100%'}>
                            <ReCAPTCHA
                              sitekey="6LfAaoMqAAAAALso7w4jqB7nKR7aJ0k4A5Uw4vGC"
                              onChange={(token) => setFieldValue('captchaToken', token)}
                              onExpired={() => setFieldValue('captchaToken', '')}
                              size="compact"
                            />
                            {touched.captchaToken && !values.captchaToken && (
                              <Typography variant="caption" color="error">
                                Please complete the reCAPTCHA.
                              </Typography>
                            )}
                          </Stack>
                        </Grid>
                      </Grid>
                    )}

                    {tabValue !== 0 && (
                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        {tabValue === 1 && values.existingUser === 'Y' && !existingUserFound ? (
                          <Button
                            onClick={() => {
                              setFieldTouched('tel', true);
                              setFieldTouched('coo', true);
                              if (!errors.tel && !errors.coo) VerifyExistingUser(values.tel, values.coo);
                            }}
                            disabled={isSubmitting}
                            variant="contained"
                            color="primary"
                            size="small"
                            sx={{ boxShadow: 1 }}
                          >
                            Get Details
                          </Button>
                        ) : (
                          <>
                            {tabValue === 3 ? (
                              <Button
                                onClick={submitForm}
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ boxShadow: 1 }}
                              >
                                Submit Registration
                              </Button>
                            ) : tabValue === 2 && !otpVerified ? null : (
                              <Button
                                onClick={(e) => {
                                  handleNext(
                                    e,
                                    values.coo,
                                    values.mailid,
                                    values.existingUser,
                                    setFieldTouched,
                                    setFieldValue,
                                    validateForm,
                                    setFieldError
                                  );
                                }}
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ boxShadow: 1 }}
                              >
                                Next
                              </Button>
                            )}
                          </>
                        )}
                      </Stack>
                    )}
                  </Form>
                )}
              </Formik>
            </Stack>
          </Paper>
          {/* Terms and Conditions Dialog */}
          <Dialog open={termsDialogOpen} onClose={() => setTermsDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Terms and Conditions</DialogTitle>
            <DialogContent dividers>
              <Typography variant="body2" component="div">
                {termsConditions.length > 0 ? (
                  <ul>
                    {termsConditions.map((term, index) => (
                      <li key={index} style={{ marginBottom: '8px' }}>
                        {term.TermsAndConditions}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No terms and conditions available at the moment.
                  </Typography>
                )}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setTermsDialogOpen(false)} variant="contained" color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>

          {/* Existing record message dialog */}
          <Dialog open={existingMessageOpen} onClose={() => { }} maxWidth="sm" fullWidth>
            <DialogContent dividers>
              {isSubmitted && (
                <img width={80} style={{ display: 'block', margin: 'auto' }} src={successIcon} alt="success icon" />
              )}
              <Typography variant="body2" sx={{ textAlign: 'center', marginBottom: 2 }}>
                {existingUserFound && (
                  <>
                    {`Dear ${existingUserData.CustomerName}, it seems you have an existing account with us. Please use the email associated with your account to proceed.`}
                  </>
                )}
                {approvalPending && (
                  <>
                    For the given mobile number, a registration has already been submitted and is pending approval.
                    Kindly check your email for more updates.
                  </>
                )}
                {alreadyRegistered && (
                  <>
                    You are already registered. Please proceed to login with the credentials provided. Further
                    registrations are not allowed.
                  </>
                )}
                {isSubmitted && (
                  <>
                    Congratulations! 🎉 Your registration has been successfully completed and is now under review for
                    approval by the administrator. Once approved, you will receive an email with your username and
                    password. Please check your email for further instructions and the next steps to complete the
                    process!
                  </>
                )}
              </Typography>
            </DialogContent>
            <DialogActions>
              <Box display="flex" justifyContent="center" width="100%">
                <Button
                  onClick={() => (existingUserFound ? setExistingMessageOpen(false) : navigate('/login'))}
                  variant="contained"
                  color={existingUserFound ? 'primary' : 'success'}
                  size="small"
                >
                  {existingUserFound ? 'Proceed' : 'Back to Login'}
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        </StyledSection>
      </StyledRoot>
    </>
  );
};

export default SignUpForm;
